<template>
  <div class="main">
    <div class="container login">
      
      <img src="../../assets/img/logo.png" alt="geberit" class="login__logo">
      <div class="alert alert-danger" role="alert" v-if="message.data">
        {{ message.data }}
      </div>
      <form method="post" class="form" v-bind:class="{pending: pending}" @submit="submit">
        <div class="form__input-container">
          <input type="email" name="email" v-model="form.email" class="form__input" placeholder="Adres e-mail" required>
        </div>
        <div class="form__input-container">
          <input type="password" name="password" v-model="form.password" class="form__input" placeholder="Nowe hasło" required>
        </div>
        <div class="form__input-container">
          <input type="password" name="password_repeat" v-model="form.password_repeat" class="form__input" placeholder="Powtórz hasło" required>
        </div>
        <div class="form__input-container">
          <button type="submit" class="button button--blue form__submit" v-bind:disabled="pending">Wyślij &raquo;</button>
        </div>
      </form>
  
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from '@/app/authentication/authentication.service'

export default {
  name: 'ForgetPassword',
  data() {
    return {
      message: {
        status: 'success',
        data: null
      },
      pending: false,
      form: {
        email: null,
        password: null,
        password_repeat: null
      }
    }
  },
  methods: {
    /**
     * Login method.
     * 
     * @return {void}
     */
    submit: function (e) {
      e.preventDefault()

      let vm = this
      vm.message.data = null
      vm.pending = true

      Vue.axios({
        method: 'post',
        url: '/password/reset',
        data: {
          email: vm.form.email,
          password: vm.form.password,
          password_confirmation: vm.form.password_repeat,
          token: vm.$route.params.token
        }
      })
      .then(response => {
        vm.pending = false
        this.$toaster.success("Hasło zostało zmienione.")
        this.$router.push('/')
      })
      .catch(error => {
        Object.keys(error.response.data.errors).forEach(function(err, eindex, earray) {
            error.response.data.errors[err].forEach(function(msg, mindex, marray) {
                vm.$toaster.error(msg)
            })
        });  

        vm.pending = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/authentication/ResetPassword.vue